import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface LoadingState {
  isOpen: boolean;
  title?: string;
}

const initialState: LoadingState = {
  isOpen: false,
  title: "",
};

const loadingSlice = createSlice({
  name: "loading",
  initialState: initialState,
  reducers: {
    openLoading: (state, action: PayloadAction<undefined | Omit<LoadingState, "isOpen">>) => {
      return {
        ...state,
        ...(action?.payload || {}),
        isOpen: true,
      };
    },
    closeLoading: () => {
      return initialState;
    },
  },
});

export const { openLoading, closeLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
